"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.and = and;
exports["default"] = void 0;
exports.not = not;
exports.or = or;
var strategies = {
  Always: function Always() {
    return true;
  },
  Touched: function Touched(metaForm, metaField) {
    return metaField.touched;
  },
  Blurred: function Blurred(metaForm, metaField) {
    return metaField.blurred;
  },
  Changed: function Changed(metaForm, metaField) {
    return metaField.changed;
  },
  ClientValidationSucceeded: function ClientValidationSucceeded(metaForm, metaField) {
    return metaField.succeeded;
  },
  Pristine: function Pristine(metaForm) {
    return metaForm.pristine;
  },
  Submitted: function Submitted(metaForm) {
    return metaForm.submitted;
  }
};
var _default = strategies;
exports["default"] = _default;

function and(a, b) {
  return function (metaForm, metaField) {
    return a(metaForm, metaField) && b(metaForm, metaField);
  };
}

function or(a, b) {
  return function (metaForm, metaField) {
    return a(metaForm, metaField) || b(metaForm, metaField);
  };
}

function not(s) {
  return function (metaForm, metaField) {
    return !s(metaForm, metaField);
  };
}